import StepProgressPanel from "./steps/step-progress-panel";
import LegalAddressAndBillingStep from "./steps/legal-address-step";
import UserTypeStep from "./steps/user-type-step";
import FinancialProfileStep from "./steps/financial-profile-step";
import CompanyNameStep from "./steps/company-name-step";
import GestionDirectoresStep from "./steps/gestion-directores-step";
import DirectorsStep from "./steps/directors-step";
import PaymentSummaryStep from "./steps/payment-summary-step";
import SuccessStep from "./steps/success-step";
import {
  GESTION_DIRECTORES,
  type IncorporationWizardInitialData,
} from "@/schemas/incorporation";
import type { StepComponentType } from "./hooks/IncorporationWizardFormContext";
import ShareholdersStep from "./steps/shareholder-step";

/**
 * Build the wizard steps based on current data.
 * DirectorsStep is conditionally shown only when gestion_directores === "cliente"
 */
export function buildSteps(_data?: IncorporationWizardInitialData) {
  const baseSteps: StepComponentType[] = [
    StepProgressPanel,
    CompanyNameStep,
    UserTypeStep,
    GestionDirectoresStep, // Radio selection for abogado/cliente
  ];

  // Conditionally add DirectorsStep only when "cliente" is selected
  const gestionDirectores = _data?.incorporationRequest?.gestion_directores;
  if (gestionDirectores === GESTION_DIRECTORES[1]) {
    // "cliente"
    baseSteps.push(DirectorsStep);
  }

  // Always add remaining steps
  baseSteps.push(
    ShareholdersStep,
    FinancialProfileStep,
    LegalAddressAndBillingStep,
    PaymentSummaryStep,
    SuccessStep
  );

  return baseSteps;
}
